import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import AppContext from '../../AppContext';
import './Loader.css';

const Loader = (props) => {
    if (props.loading) {
        let appContext = new AppContext();
        let primaryColor = '#000';
        try {
            primaryColor = appContext.getPlatformConfig().customStyles.charlyHomeColor;
        } catch (err) {}
        return (
            <div className="pdc-general-loader">
                <CircularProgress
                    style={{
                        color: props.primaryColor ? props.primaryColor : primaryColor,
                        paddingLeft: props.padding ? props.padding : 0,
                        paddingRight: props.padding ? props.padding : 0,
                    }}
                    size={props.size ? props.size : 22}
                />
                {/* <Icon name="fa-refresh" padding={props.padding} size={props.size} primaryColor={props.primaryColor} /> */}
            </div>
        );
    } else {
        return '';
    }
};
Loader.propTypes = {
    loading: PropTypes.bool.isRequired,
    size: PropTypes.string,
    primaryColor: PropTypes.string,
    padding: PropTypes.number,
};

export default Loader;
